import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
// eslint-disable-next-line
import { getProductsList } from "../../../helpers/listsApi";
import { imagePath } from "../../../utils/assetUtils";
import "./DashboardData.scss";
import { decimalTo } from '../../../utils/utils';


//comps
import DashboardNum from "./dashBoardNum/DashBoardNum";

//img
const DashBoardDataIcon = imagePath("blank-profile.png");
const Sold = imagePath("bx-list-ul-black.svg");
const Money = imagePath("bx-money.svg");
const SiteMap = imagePath("bx-sitemap-dark.svg");
const PackageIcon = imagePath("bx-package.svg")

export default function DashboardData(props) {
  const { userName: username, userType: role } = useSelector((state) => state.auth.user);
   const region = useSelector((state) => state.auth.region);
  const token = useSelector((state) => state.auth.token);
  const { totalMerchents, totalOrder, totalOrderAmount, balance } = props;
  const [ productAvailable, setProductAvailable ] = useState(0)
  //async
  useEffect(() => {
    getProductsList(null,token)
      .then((res) => {
        setProductAvailable(res.length ? res.length : 0)
      })
      .catch((err) => console.log(err));
  }, [token]);

  return (
    <div className="col-sm-12">
      <div className="box-row">
        <h1 className="sec-header mt-3">DASHBOARD</h1>
        <div className="row dashboard-row">
          
          {
            role !== 3 && (
              <div className={role !== 3 ? "col-xl-3 col-md-6 mb-sm-2" : "col-xl-4 col-md-6 mb-sm-2"}>
                <div className="card dash-num-card h-100">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-md-4 col-sm-12">
                        <div className="card-profile text-center">
                          <img src={DashBoardDataIcon} alt="nodwin" className="img-fluid imgRes" />

                        </div>
                      </div>
                      <div className="col-md-8 col-sm-12 card1">
                        <p className="mt-2">{username}</p>
                        <div className="designation">{
                          role === 1 && "Super Admin"
                        }{
                            role === 2 && "Admin Agent"
                          }{
                            role === 3 && "Merchant"
                          }{
                            role === 4 && "Customer Support"
                          }</div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            )
          }

          {
            role === 3 && (
              <DashboardNum
                text={`Available Balance${region?.currency ? ` (${region.currency})` : ''}`}
                // image={Balance}
                image={Money}
                 count={
                  Array.isArray(balance) &&
                  balance.length > 0 &&
                  balance[0]?.creditAvalable != null
                    ? decimalTo(balance[0].creditAvalable).toFixed(2)
                    : 0
                }
              />
            )
          }

          <DashboardNum
            // text="Total Sales"
            text="Total Orders"
            image={Sold}
            count={totalOrder || 0}
          />
          <DashboardNum
             text={
              region && region.currency
                ? `Total Orders Amount (${region.currency})`
                : "Total Orders Amount"
            }
            image={Money}
            setnum={true}                
            count={decimalTo(totalOrderAmount).toFixed(2) || 0}
          />
          {
            role === 3 && (
              <DashboardNum
                text="Products Available"
                image={PackageIcon}
                count={productAvailable || 0}
              />
            )
          }
          {role !== 3 ? <DashboardNum
            text="Total Merchants"
            image={SiteMap}
            count={totalMerchents || 0}
          /> : null}
        </div>
      </div>
    </div>
  );
}
